export const WHATSAPP_WIDGET_OPEN_EVENT = 'crs:open-whatsapp-widget'
export const WHATSAPP_WIDGET_PANEL_ID = 'whatsapp-widget-panel'

export function openWhatsAppWidget({ clickLocation = 'unknown', source = 'site_cta' } = {}) {
  if (typeof document === 'undefined') return
  document.dispatchEvent(new CustomEvent(WHATSAPP_WIDGET_OPEN_EVENT, {
    detail: { clickLocation, source },
  }))
}
